<template>
  <v-dialog
    max-width="600"
    :value="true"
    persistent>
    <v-card>
      <v-card-title>
        <h2>{{ editing ? 'Edit' : 'New' }} Provider</h2>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          @submit.prevent="submit">

          <label>Provider Type</label>
          <v-select
            v-model="provider.type"
            :items="[
              { text: 'Attorney', value: 'attorney' },
              { text: 'Compliance Consultant', value: 'compliance' },
              { text: 'CPA', value: 'cpa' },
              { text: 'E&O Provider', value: 'eo' },
            ]"
            label="Provider Type"
            solo
            required />

          <label>Company Name</label>
          <v-text-field
            v-model="provider.companyName"
            label="Company Name"
            solo
            required />

          <label>Contact Name</label>
          <v-text-field
            v-model="provider.contactName"
            label="Contact Name"
            solo
            :rules="validateName"
            validate-on-blur />

          <label>Email Address</label>
          <v-text-field
            v-model="provider.email"
            label="email@email.com"
            solo
            :rules="validateEmailNotRequired"
            validate-on-blur />

          <label>Phone Number</label>
          <v-text-field
            v-model="provider.phone"
            label="(555)555-5555"
            solo
            v-mask="maskPhone"
            :rules="validatePhoneNotRequired"
            validate-on-blur />

          <label>Website</label>
          <v-text-field
            v-model="provider.linkWebsite"
            label="https://website.com"
            solo />

          <label>LinkedIn Profile</label>
          <v-text-field
            v-model="provider.linkLinkedin"
            label="https://www.linkedin.com/in/profile-link"
            solo />

          <label>Address</label>
          <v-text-field
            v-model="provider.addressLine_1"
            label="Line 1"
            solo />

          <v-text-field
            v-model="provider.addressLine_2"
            label="Line 2"
            solo />

          <v-text-field
            v-model="provider.addressCity"
            label="City"
            solo />

          <v-text-field
            v-model="provider.addressState"
            label="State"
            solo />

          <v-text-field
            v-model="provider.addressZip"
            label="Zip Code"
            solo />

          <label>Provider Description</label>
          <v-textarea
            v-model="provider.description"
            solo
            required />
        </v-form>

        <LogoInput
          :provider="provider"
          @change="updateLogo" />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <button
          class="default-btn blue"
          :disabled="saving"
          @click="submit">
          <span>{{ editing ? 'Update' : 'Create' }}</span>
          <v-icon v-if="saving" right>
            mdi-loading mdi-spin
          </v-icon>
        </button>

        <button
          class="default-btn text"
          @click="$emit('cancel')">
          Cancel
        </button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formMixin } from '@/mixins'

import LogoInput from './LogoInput'

export default {
  name: 'CreateEditProvider',
  mixins: [formMixin],
  components: {
    LogoInput,
  },
  props: {
    originalProvider: {
      type: Object,
      default: () => ({}),
    },
    editing: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    provider: {},

    maskPhone: ['(', /\d/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  }),

  created () {
    this.provider = Object.assign({}, this.originalProvider)
  },

  methods: {
    submit () {
      if (!this.$refs.form.validate()) return

      this.$emit('submit', this.provider)
    },

    updateLogo (uri) {
      this.provider.logoFile = { uri }
      this.provider.logo = uri
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
